import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { uploadInChunks } from "src/domains/projects-list/api/chunkedUpload/uploadInChunks";

export interface UploadDrawingAlignmentParams {
  /**
   * 정렬이 앉을 도면의 식별자 — dwg 업로드 **응답**의 `name` 에서 뗀 stem 이다.
   * 요청에 실어 보낸 이름이 아니다: 중복 회피가 `A.dwg` 를 `A(1).dwg` 로 바꿔 보낼 수 있고,
   * 그때 요청 이름(`A`)은 **다른 도면**을 가리킨다.
   */
  drawingName: string;
  /** 업로드 파일명 `{이름}.dxf`. NFD 정규화는 호출 측 책임. */
  fileName: string;
  /** 정렬 dxf 원본 바이너리. */
  file: File;
}

export interface UploadDrawingAlignmentResponse {
  /** 슬롯에 놓인 정렬 파일명(basename + NFD 정규화) — 이전 슬롯 객체는 이때 제거된다. */
  name: string;
}

/**
 * 도면의 정렬 슬롯에 dxf 를 놓는다 — dwg 채널과 **같은** 512KB 청크 규약(`uploadInChunks` 공용
 * 헬퍼 위임)이고 다른 것은 `drawing_name` 이 **매 청크** 실린다는 것 하나다(토큰이 실어 온 키가 그
 * 도면의 슬롯인지 대조하는 scope 가드).
 *
 * 서버가 스스로 거르는 것: `.dxf` 아닌 확장자(400) · 같은 이름의 dwg 앵커 부재(400) · 그 도면이
 * 빌드 중(409) · 권한(비멤버 404 · 멤버지만 writer 아님 403). 그래서 이 함수에는 사전 검사가 없다.
 *
 * 슬롯은 도면당 하나라 같은 도면에 다시 올리면 **교체**다 — 실패한 정렬을 다시 거는 것이 멱등한
 * 이유이자, 슬롯을 비우는 연산이 없는 이유다.
 */
export async function uploadDrawingAlignment(
  projectId: number,
  { drawingName, fileName, file }: UploadDrawingAlignmentParams
): Promise<UploadDrawingAlignmentResponse> {
  const name = await uploadInChunks<string>({
    url: `${backendBaseUrl()}/projects/${projectId}/drawing-meshes/alignment/uploads`,
    fileName,
    file,
    fields: { drawing_name: drawingName },
    pickCompletion: (data) => data.name as string | undefined,
    label: "정렬 dxf 업로드",
  });
  return { name };
}
